import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoGridOneColumn, RaikoTableTitleContainer, showErrorMessage,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator
} from "../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";
import {useAuthState} from "../../context/AuthContext";
import {useParams} from "react-router-dom";
import {ElectionService} from "../../serverService/electionService/ElectionService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import Pagination from "@mui/material/Pagination";
import {css} from "@emotion/css";
import {Skeleton} from "@mui/lab";
import * as React from "react";

export default function ElectionResultDetails({candidateId}) {

    const {fundID} = useAuthState()
    const {id: electionId} = useParams()
    const service = new ElectionService()
    const loading = new LoadingHelper(useLoadingDispatcher())
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const size = 5;
    const [electionResultDetailsData, setElectionResultDetailsData] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    useEffect(() => {
        getElectionResultDetailsFromServer()
    }, [fundID])

    function getElectionResultDetailsFromServer() {
        setLoadingState(true)
        service.getElectionVotes(fundID, electionId, candidateId, page, size).then(
            response => {
                setPageCount(response.totalPage)
                setElectionResultDetailsData(response.data)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setLoadingState(false)
        })
    }

    function handleChangePage(event, value) {
        setPage(value - 1)
        getElectionResultDetailsFromServer()
    }


    return (
        <RaikoGridOneColumn>
            {loadingState ? <Skeleton variant="rectangular" className={css`padding: 32px;`}/> :
                <div>{electionResultDetailsData && electionResultDetailsData.length > 0 ?
                    <div className={css`gap: 1rem`}>
                        <RaikoTableTitleContainer title={"جزئیات آرا"}/>
                        {electionResultDetailsData.map((item, index) => {
                            return <RaikoCardInfoTypeOne
                                titleLabel={"شناسه"}
                                title={item.id}
                                items={[
                                    RaikoCardInfoTypeOneItemGenerator(
                                        "نام و نام خانوادگی",
                                        item.firstName + item.lastName,
                                    ),
                                    RaikoCardInfoTypeOneItemGenerator(
                                        "نام کاربری",
                                        item.username,
                                    ),
                                    RaikoCardInfoTypeOneItemGenerator(
                                        "تاریخ ثبت",
                                        convertUniversalDateTimeToPersianDateTime(item.submitAt),
                                    ),
                                ]}
                            />
                        })
                        }
                        <div className={css`width: 100%;
                          display: flex;
                          justify-content: center`}>
                            <Pagination
                                count={pageCount}
                                onChange={handleChangePage}
                            />
                        </div>
                    </div> : <div>هیچ کاربری به این گزینه رای نداده است!</div>}</div>}


        </RaikoGridOneColumn>
    )
}